import voca from 'voca';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ALPHA, BETA, PREVIEW, PRODUCTION } from './environments';
import { updateUserIpInCookie } from './api_utils';
import { builderSurfaceJsonContentHeader } from './restApiHeaderUtils';
import showAlert from './alert';
import { loadOrganizationDetails } from './check-auth';
import cookie from 'react-cookies';

const {
  REACT_APP_EXCHANGE_ENGINE,
  REACT_APP_EXCHANGE_ENGINE_ALPHA,
  REACT_APP_EXCHANGE_ENGINE_BETA,
  REACT_APP_EXCHANGE_ENGINE_PREVIEW,
  REACT_APP_BUILDER_ENGINE,
} = process.env;

export const publishAppOnServer = async (
  envType,
  name,
  updateState,
  selVersion,
  projectDetail,
  actions,
) => {
  const preConfirm = async () => {
    updateState(true);
    let exchangeEngineUrl = REACT_APP_EXCHANGE_ENGINE;
    if (envType === ALPHA) {
      exchangeEngineUrl = REACT_APP_EXCHANGE_ENGINE_ALPHA;
    } else if (envType === BETA) {
      exchangeEngineUrl = REACT_APP_EXCHANGE_ENGINE_BETA;
    } else if (envType === PRODUCTION) {
      exchangeEngineUrl = REACT_APP_EXCHANGE_ENGINE;
    } else if (envType === PREVIEW) {
      exchangeEngineUrl = REACT_APP_EXCHANGE_ENGINE_PREVIEW;
    }
    const { seoName, uuid } = projectDetail;
    let environment = process.env.REACT_APP_ENVIRONMENT || '';
    if (environment) {
      environment = environment.toLowerCase().trim();
    }
    let protocol = 'https';
    //Overriding publish Exchange Engine API URL protocol for DEV environment
    if (environment.startsWith('dev')) {
      protocol = `http`;
    }

    const publishURL = `${protocol}://${seoName}.${exchangeEngineUrl}api/v1/projects/build/${uuid}/version/${selVersion}`;
    try {
      toast.info('Started Publishing the Application.');
      await actions.updateLatestPublishVersion({
        projectId: uuid,
        latestVersion: selVersion,
        envType,
      });
      const res = await axios.post(
        publishURL,
        { subscription: loadOrganizationDetails('subscription') },
        {
          headers: {
            'Content-Type': 'application/json',
            projectId: uuid,
          },
        },
      );

      updateState(false);
      if (res.data.message === 'Build Success') {
        await updatePublishSaveData(uuid, selVersion, envType);
        toast.success('Application Published Successfully!');
        return { success: true, data: res.data };
      } else {
        toast.error(`Failed to Publish the  Application`, {});
        return { success: false, error: 'Failed to Publish the  Application' };
      }
    } catch (error) {
      updateState(false);
      if (error.message.toString().toLowerCase() === 'network error') {
        toast.error(`Failed: Try again after sometime`, {});
      } else {
        toast.error(`Failed: ${error.message}`, {});
        return { success: false, error: error.message };
      }
    }
  };

  if (envType === PREVIEW) {
    return await preConfirm();
  } else {
    const title = `You are going to publish the project in ${name}:(${voca.titleCase(
      envType,
    )}) environment. Are you sure?`;
    showAlert(title, preConfirm, 'Publish');
  }
};

export const updatePublishSaveData = async (uuid, version, envType) => {
  try {
    const userIp = cookie.load('userIp') || (await updateUserIpInCookie());
    let header = builderSurfaceJsonContentHeader(uuid, true, userIp);
    header.headers['x-project-env'] = envType;
    await axios.post(
      `${REACT_APP_BUILDER_ENGINE}publish/savedata`,
      { projectId: uuid, version },
      header,
    );
  } catch (error) {
    console.log('error in tracking publish', error);
  }
};
